import {Component} from '@angular/core';
import {UrlService} from '../../../services/url.service';
import {StripeAccountsService} from '../../../services/stripe-accounts.service';

@Component({
    selector: 'stripe-payouts-list',
    templateUrl: './stripe-payouts-list.component.html',
    styleUrls: ['./stripe-payouts-list.component.scss']
})
export class StripePayoutsListComponent {

    constructor(
        public urlService: UrlService,
        public stripeAccountsService: StripeAccountsService
    ) {}

    orderBy(orderBy: string, $event) {
        if (this.stripeAccountsService.data.total < 2) return;
        this.urlService.orderBy(orderBy, $event);
    }
}



// WEBPACK FOOTER //
// /app/src/app/views/stripe-accounts/stripe-payouts-list/stripe-payouts-list.component.ts